import { gql } from "@apollo/client";
import { minimize_str } from "@core/helpers/string";
import seo, { prefix_urls, prefix_urls_banners, prefix_urls_popups } from "@core/gql-mockups/seo";

const GET_SITEMAP_URLS = gql`
  query {
    result: getSitemapUrls {
      url
      last_modified
      priority
      change_frequency
      slugs
    }
  }
`;

const GET_SEOS = gql`
  query ($filter: SEOFilter) {
    result: getSEOs (filter: $filter) {
      data ${seo}
    }
  }
`;


const GET_SEO_JSON = gql`
  query ($url: String) {
    result: getSEO_JSON (url: $url)
  }
`;

const GET_PREFIX_URLS = gql`
  query ($url: String) {
    result: getPrefixUrlDetails (url: $url) ${prefix_urls}
  }
`;

const GET_PREFIX_URLS_POPUPS = `
  query ($url: String) {
    result: getPrefixUrlDetails (url: $url) ${prefix_urls_popups}
  }
`;

const GET_PREFIX_URLS_BANNERS = minimize_str(`
  query ($url: String) {
    result: getPrefixUrlDetails (url: $url) ${prefix_urls_banners}
  }
`);

const GET_PREFIX_URL_REDIRECT = gql`
  query ($url: String) {
    result: getPrefixUrlDetails (url: $url) {
       redirect {
        url
        status_code
      }
    }
  }
`;

/* Page query with a caller-supplied `widgets` selection (see widgets_prefix_with_cards).
   Same fields as GET_PREFIX_URLS otherwise. */
const make_get_prefix_urls = (widgets_mockup) => `
  query ($url: String) {
    result: getPrefixUrlDetails (url: $url) {
      found
      slug
      model_name
      model_type
      page_type
      key
      seo {
        title
        key
        url
        redundancy_model_title
      }
      widgets ${widgets_mockup}
    }
  }
`;

export { make_get_prefix_urls };

export { GET_SITEMAP_URLS, GET_SEOS, GET_PREFIX_URLS, GET_SEO_JSON, GET_PREFIX_URL_REDIRECT, GET_PREFIX_URLS_POPUPS, GET_PREFIX_URLS_BANNERS };
